export function InConstruction() {
	return (
		<h2 className="text-center p-8 text-blue-800">
			Próximamente estaremos habilitando esta opción, para que puedas pagar tus servicios en
			línea.
		</h2>
	)
}

export function InConstructionArbitrios() {
	return (
		<h2 className="text-center p-8 text-blue-800">
			Próximamente estaremos habilitando esta opción, para que puedas conocer tus arbitrios en
			línea.
		</h2>
	)
}